import { useEffect, useState } from 'react'

import { checklistStatusTypes } from 'constants/checklist'
import Cookie from 'helpers/cookie'
import { notify } from 'helpers/notification.js'
import { isObjectEmpty } from 'helpers/object'
import { getRoomName } from 'helpers/room'
import { removeAuthTokens, setupAuthTokens } from 'helpers/token'
import { getQueryParams } from 'helpers/urls'
import { getAuthTokens } from 'services/apis/room'
import { dispatchSetChecklistStatus } from 'store/dispatcher'
import creds from 'utils/creds'
import { logger } from 'utils/logger'

const processDevHooks = async () => {
    const queries = getQueryParams()
    const roomName = getRoomName()

    if (isObjectEmpty(queries)) return // no queries to process

    const { skip, userId } = queries
    const skips = {
        checklist: skip?.includes('checklist'),
        login: skip?.includes('login'),
    }

    if (skips.login) {
        const tokens = await getAuthTokens({ roomName })
        delete Cookie.defaults.expires // change Cookies to Session only
        setupAuthTokens(tokens)
    }

    if (skips.checklist) {
        dispatchSetChecklistStatus(checklistStatusTypes.SKIP)
    }

    if (!skips.login && userId) {
        const user = creds.find(cred => cred.uuid === userId)
        if (!user) throw new Error('not a valid user from creds.js')
        const tokens = await getAuthTokens({ phoneNumber: user.phone })
        setupAuthTokens(tokens)
    }
}

const useDevHooks = () => {
    const [processing, setProcessing] = useState(true)

    useEffect(() => {
        ;(async () => {
            try {
                await processDevHooks()
            } catch (error) {
                notify.error([`Dev Hooks processing failed`, error.message])
                logger.error({ msg: `Dev Hooks processing failed.`, error })
            } finally {
                setProcessing(false)
            }
        })()
    }, [])

    useEffect(() => {
        const queries = getQueryParams()
        const skipLogin = queries?.skip?.includes('login')

        const removeCookies = () => skipLogin && removeAuthTokens()

        window.addEventListener('beforeunload', removeCookies)
        return () => {
            window.removeEventListener('beforeunload', removeCookies)
        }
    }, [])

    return processing
}

export default useDevHooks
